import { render } from "./ProjectPages.vue?vue&type=template&id=af116688"
import script from "./ProjectPages.vue?vue&type=script&lang=js"
export * from "./ProjectPages.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__